<template>
  <button v-if="game.status === 'ARCHIVED'" @click="downloadPDF(game.uuid)" class="btn btn-sm btn-primary" v-tooltip="$t('tooltip.downloadGamePdf')"><i v-if="loading" class="fa fa-spinner fa-spin"></i> <i class="fa fa-file-pdf-o" v-if="!loading"></i></button>
</template>

<script>
import ExportService from '../../services/export.service'

export default {
  name: 'PdfDownload',
  data () {
    return {
      loading: false
    }
  },
  props: {
    game: {
      type: Object
    },
    league: {
      type: Object
    },
    round: {
      type: String
    }
  },
  methods: {
    downloadPDF () {
      this.loading = true
      ExportService.gamePdf(this.game.uuid).then((response) => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]))
        const fileLink = document.createElement('a')
        fileLink.href = fileURL
        fileLink.setAttribute('download', `${this.filename}.pdf`)
        document.body.appendChild(fileLink)
        fileLink.click()
      }).finally(() => {
        this.loading = false
      })
    }
  },
  computed: {
    filename () {
      return `${this.league.season.name}==${this.league.name}==${this.round}==${this.game.teamA.name} vs ${this.game.teamB.name}`
    }
  }
}
</script>
